import { render } from "./SynthesisFormPopup.vue?vue&type=template&id=a0c36384&scoped=true&ts=true"
import script from "./SynthesisFormPopup.vue?vue&type=script&lang=ts"
export * from "./SynthesisFormPopup.vue?vue&type=script&lang=ts"

import "./SynthesisFormPopup.vue?vue&type=style&index=0&id=a0c36384&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0c36384"]])

export default __exports__